import { AcessoriosDTO, AnuncioTableDTO, VehiclePackage } from "../dto/CompanyDTO";
import { CurrentTabAds } from "../enums/CompanyEnums";


export const combustiveis = [
{id: 1, label:"Ácool"},
{id: 2, label:"Bí-Combustível"},
{id: 3, label:"Gasolina"},
{id: 4, label:"Gasolina + Kit Gás"},
{id: 5, label:"Diesel"},
{id: 6, label:"Tetra Fuel"},
{id: 7, label:"Híbrido Leve"},
{id: 8, label:"Híbrido"},
{id: 9, label:"Híbrido Plug-In"},
{id: 10, label:"Elétrico"},
];

export const transmissao = [
{id:1, label:"Manual"},
{id:2, label:"Automático"},
{id:3, label:"Semi-Automático"},
{id:4, label:"Automatizado"},
];

export const newAdsOrVeichle = [
{label: 'Anúncio individual', page: CurrentTabAds.NewAds},
{label:'Veículo para Anúncio Combo', page: CurrentTabAds.NewVeichle}
];

export const TitleNewAdsOrVeichle = [
'Novo Anúncio Venda', 'Veículo para Anúncio Combo'
];

export const typeOfVehicle = [
{id:1, label:"Carro"},
{id:2, label:"Moto"},
{id:3, label:"Caminhão"},
];

export const acessoriosMock: AcessoriosDTO[] = [
{ id: 1, label: "ABS", isActive: false },
{ id: 2, label: "Air Bag", isActive: false },
{ id: 3, label: "Air Bag Duplo", isActive: false },
{ id: 4, label: "Air Bags 4", isActive: false },
{ id: 5, label: "Alarme", isActive: false },
{ id: 6, label: "Anti Furto", isActive: false },
{ id: 7, label: "Ar Condicionado", isActive: false },
{ id: 8, label: "Ar Quente", isActive: false },
{ id: 9, label: "Bagageiro", isActive: false },
{ id: 10, label: "Bancos de Couro", isActive: false },
{ id: 11, label: "Blindado", isActive: false },
{ id: 12, label: "Câmbio Automático", isActive: false },
{ id: 13, label: "Capota Marítima", isActive: false },
{ id: 14, label: "Carro Básico", isActive: false },
{ id: 15, label: "CD / MP3", isActive: false },
{ id: 16, label: "Central Multimídia", isActive: false },
{ id: 17, label: "Computador de Bordo", isActive: false },
{ id: 18, label: "Desembaçador", isActive: false },
{ id: 19, label: "Direção Elétrica", isActive: false },
{ id: 20, label: "Direção Hidráulica", isActive: false },
{ id: 21, label: "DVD", isActive: false },
{ id: 22, label: "Engate", isActive: false },
{ id: 23, label: "Faróis de Milha", isActive: false },
{ id: 24, label: "Farol Xenônio", isActive: false },
{ id: 25, label: "Limpador Traseiro", isActive: false },
{ id: 26, label: "MP3 / USB", isActive: false },
{ id: 27, label: "Piloto Automático", isActive: false },
{ id: 28, label: "Protetor de Caçamba", isActive: false },
{ id: 29, label: "Quebra Mato", isActive: false },
{ id: 30, label: "Rádio", isActive: false },
{ id: 31, label: "Rebaixado", isActive: false },
{ id: 32, label: "Retrovisores Elétricos", isActive: false },
{ id: 33, label: "Rodas de Liga Leve", isActive: false },
{ id: 34, label: "Santo Antônio", isActive: false },
{ id: 35, label: "Sensor de Estacionamento", isActive: false },
{ id: 36, label: "Teto Solar", isActive: false },
{ id: 37, label: "Toca-fitas", isActive: false },
{ id: 38, label: "Tração 4x4", isActive: false },
{ id: 39, label: "Travas Elétricas", isActive: false },
{ id: 40, label: "Trio Elétrico", isActive: false },
{ id: 41, label: "Turbo", isActive: false },
{ id: 42, label: "Vidro Escurecido", isActive: false },
{ id: 43, label: "Vidros Elétricos", isActive: false },
{ id: 44, label: "Volante Ajustável", isActive: false },
{ id: 45, label: "7 Lugares", isActive: false },
{ id: 46, label: "Ar-condicionado Digital", isActive: false },
{ id: 47, label: "Assistente de Partida em Rampa", isActive: false },
{ id: 48, label: "AWD", isActive: false },
{ id: 49, label: "Banco com Ajuste de Altura", isActive: false },
{ id: 50, label: "Câmera de Ré", isActive: false },
{ id: 51, label: "Central Multimídia", isActive: false },
{ id: 52, label: "Controle de Estabilidade", isActive: false },
{ id: 53, label: "Controle de Tração", isActive: false },
{ id: 54, label: "Conversível", isActive: false },
{ id: 55, label: "EBD", isActive: false },
{ id: 56, label: "Faróis LED", isActive: false },
{ id: 57, label: "GPS", isActive: false },
{ id: 58, label: "Volante com Comando Multimídia", isActive: false },
];
export const mockVeiculos: VehiclePackage[] = [
{ id: 11481,modelo: "GM - Fiat Toro 1.3 Turbo. MME-2300",status: "Inativo",url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg" },
{ id: 2,modelo: "GM - Jeep Compass Limited. MME-2300", status: "Inativo",url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg" },
{ id: 3,modelo: "GM - Toyota Corolla XEi. MME-2300", status: "InInativo",url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg" },
{ id: 4,modelo: "GM - Honda Civic Touring. MME-2300",status: "Inativo",url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg" },
{ id: 5,modelo: "GM - Volkswagen T-Cross Highline. MME-2300",status: "Inativo",url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg" },
{ id: 6,modelo: "GM - Chevrolet Tracker Premier. MME-2300",status: "InInativo" ,url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg"},
{ id: 7,modelo: "GM - Hyundai Creta Platinum. MME-2300",status: "Inativo" ,url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg"},
{ id: 8,modelo: "GM - Nissan Kicks Exclusive. MME-2300",status: "Inativo" ,url_img:"https://upload.wikimedia.org/wikipedia/commons/c/ce/Orange_Enzo_Ferrari_%287191948164%29.jpg"},
{ id: 9,modelo: "GM - Ford Ranger XLT. MME-2300",status: "Inativo" },
{ id: 10, modelo: "GM - Chevrolet Onix RS",status: "Inativo" },
{ id: 11, modelo: "GM - Renault Duster Iconic",status: "InInativo" },
{ id: 12, modelo: "GM - Peugeot 2008 Allure",status: "Inativo" },
{ id: 13, modelo: "GM - Citroën C4 Cactus Shine",status: "Inativo" },
{ id: 14, modelo: "GM - BMW X1 sDrive20i", status: "Inativo" },
{ id: 15, modelo: "Mercedes-Benz GLA 200",status: "InInativo" },
{ id: 16, modelo: "Audi Q3 Performance",status: "Inativo" },
{ id: 17, modelo: "Volvo XC40 Momentum",status: "Inativo" },
{ id: 18, modelo: "Kia Sportage EX",status: "Inativo" },
{ id: 19, modelo: "Mitsubishi Outlander", status: "InInativo" },
{ id: 20, modelo: "Toyota Hilux SRX", status: "Inativo" },
];

export const anunciosMock: AnuncioTableDTO[] = [
  {
    id: 1,
    veiculo: "Toyota Corolla 2020",
    concessionaria: "Auto Prime SP",
    data_cadastro: "2025-01-05",
    val_inicial: 85000,
    melhor_oferta: 87000,
    status: "Em aberto",
    views: 124,
    tipo_anuncio: "L",
  },
  {
    id: 2,
    veiculo: "Honda Civic 2019",
    concessionaria: "Honda Center RJ",
    data_cadastro: "2025-01-08",
    val_inicial: 92000,
    melhor_oferta: 95000,
    status: "Vendido",
    views: 210,
    tipo_anuncio: "N",
  },
  {
    id: 3,
    veiculo: "Volkswagen Jetta 2018",
    concessionaria: "VW Premium",
    data_cadastro: "2025-01-10",
    val_inicial: 78000,
    melhor_oferta: 0,
    status: "Encerrado",
    views: 98,
    tipo_anuncio: "C",
  },
  {
    id: 4,
    veiculo: "Chevrolet Onix 2021",
    concessionaria: "Chevrolet Minas",
    data_cadastro: "2025-01-12",
    val_inicial: 68000,
    melhor_oferta: 70500,
    status: "Em aberto",
    views: 156,
    tipo_anuncio: "P",
  },
  {
    id: 5,
    veiculo: "Jeep Compass 2022",
    concessionaria: "Jeep Experience",
    data_cadastro: "2025-01-15",
    val_inicial: 142000,
    melhor_oferta: 148000,
    status: "Inativo",
    views: 312,
    tipo_anuncio: "L",
  },
  {
    id: 6,
    veiculo: "Fiat Argo 2020",
    concessionaria: "Fiat Center Sul",
    data_cadastro: "2025-01-18",
    val_inicial: 59000,
    melhor_oferta: 61000,
    status: "Vendido",
    views: 187,
    tipo_anuncio: "N",
  },
  {
    id: 7,
    veiculo: "Ford Ranger 2021",
    concessionaria: "Ford Trucks",
    data_cadastro: "2025-01-20",
    val_inicial: 175000,
    melhor_oferta: 180000,
    status: "Em aberto",
    views: 264,
    tipo_anuncio: "C",
  },
  {
    id: 8,
    veiculo: "Hyundai HB20 2019",
    concessionaria: "Hyundai Star",
    data_cadastro: "2025-01-22",
    val_inicial: 56000,
    melhor_oferta: 58000,
    status: "Vendido",
    views: 198,
    tipo_anuncio: "P",
  },
  {
    id: 9,
    veiculo: "Nissan Kicks 2020",
    concessionaria: "Nissan Zone",
    data_cadastro: "2025-01-25",
    val_inicial: 74000,
    melhor_oferta: 76000,
    status: "Em aberto",
    views: 143,
    tipo_anuncio: "L",
  },
  {
    id: 10,
    veiculo: "Renault Duster 2021",
    concessionaria: "Renault Plus",
    data_cadastro: "2025-01-27",
    val_inicial: 89000,
    melhor_oferta: 90500,
    status: "Inativo",
    views: 176,
    tipo_anuncio: "N",
  },
  {
    id: 11,
    veiculo: "BMW 320i 2018",
    concessionaria: "BMW Motors",
    data_cadastro: "2025-01-28",
    val_inicial: 155000,
    melhor_oferta: 160000,
    status: "Vendido",
    views: 322,
    tipo_anuncio: "C",
  },
  {
    id: 12,
    veiculo: "Audi A3 2019",
    concessionaria: "Audi Prime",
    data_cadastro: "2025-01-30",
    val_inicial: 138000,
    melhor_oferta: 140000,
    status: "Em aberto",
    views: 287,
    tipo_anuncio: "P",
  },
  {
    id: 13,
    veiculo: "Toyota Hilux 2022",
    concessionaria: "Toyota Trucks",
    data_cadastro: "2025-02-01",
    val_inicial: 215000,
    melhor_oferta: 220000,
    status: "Inativo",
    views: 401,
    tipo_anuncio: "L",
  },
  {
    id: 14,
    veiculo: "Peugeot 208 2020",
    concessionaria: "Peugeot France",
    data_cadastro: "2025-02-03",
    val_inicial: 62000,
    melhor_oferta: 64000,
    status: "Vendido",
    views: 165,
    tipo_anuncio: "N",
  },
  {
    id: 15,
    veiculo: "Citroën C4 Cactus 2021",
    concessionaria: "Citroën House",
    data_cadastro: "2025-02-05",
    val_inicial: 98000,
    melhor_oferta: 99500,
    status: "Em aberto",
    views: 152,
    tipo_anuncio: "C",
  },
  {
    id: 16,
    veiculo: "Volkswagen T-Cross 2022",
    concessionaria: "VW Motors",
    data_cadastro: "2025-02-07",
    val_inicial: 112000,
    melhor_oferta: 115000,
    status: "Vendido",
    views: 241,
    tipo_anuncio: "P",
  },
  {
    id: 17,
    veiculo: "Chevrolet Tracker 2021",
    concessionaria: "Chevrolet Prime",
    data_cadastro: "2025-02-09",
    val_inicial: 105000,
    melhor_oferta: 107000,
    status: "Inativo",
    views: 189,
    tipo_anuncio: "L",
  },
  {
    id: 18,
    veiculo: "Kia Seltos 2022",
    concessionaria: "Kia Motors",
    data_cadastro: "2025-02-11",
    val_inicial: 118000,
    melhor_oferta: 120000,
    status: "Em aberto",
    views: 134,
    tipo_anuncio: "N",
  },
  {
    id: 19,
    veiculo: "Mercedes-Benz C180 2017",
    concessionaria: "Mercedes Elite",
    data_cadastro: "2025-02-13",
    val_inicial: 165000,
    melhor_oferta: 168000,
    status: "Vendido",
    views: 356,
    tipo_anuncio: "C",
  },
  {
    id: 20,
    veiculo: "Fiat Toro 2023",
    concessionaria: "Fiat Prime",
    data_cadastro: "2025-02-15",
    val_inicial: 135000,
    melhor_oferta: 138000,
    status: "Em aberto",
    views: 279,
    tipo_anuncio: "P",
  },
];
